// extracted by mini-css-extract-plugin
module.exports = {"contCard":"Card_contCard__3X6dA","img":"Card_img__3PQ_F","name":"Card_name__1c9ra","types":"Card_types__1gkhC"};